import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Welcome",
    component: () => import("../views/welcome.vue")
  },
  {
    path: "/introduction",
    name: "Introduction",
    component: () => import("../views/Introduction.vue")
  },
  {
    path: "/thirteen-city",
    name: "ThirteenCity",
    component: () => import("../views/thirteen-city.vue")
  },
  {
    path: "/detail/:where",
    name: "Detail",
    component: () => import("../views/detail.vue")
  },
  {
    path: "/detail-2/:where",
    name: "Detail2",
    component: () => import("../views/detail-2.vue")
  },
  {
    path: "/two-phone-qrcode/:where",
    name: "TwoPhoneQrcode",
    component: () => import("../views/two-phone-qrcode.vue")
  },
  {
    path: "/two-phone-scan-code/:where/:uuid",
    name: "TwoPhoneScanCode",
    component: () => import("../views/two-phone-scan-code.vue")
  },
  {
    path: "/view-video/:where/:position/:uuid",
    name: "ViewVideo",
    component: () => import("../views/view-video.vue")
  },
  {
    path: "/end-alone/:where",
    name: "EndAlone",
    component: () => import("../views/end-alone.vue")
  },
  {
    path: "/end-two-phone/:where/:position",
    name: "EndTwoPhone",
    component: () => import("../views/end-two-phone.vue")
  },
  {
    path: "/test",
    component: () => import("../views/test.vue")
  }
];

const router = new VueRouter({
  routes
});

export default router;
